/**
 * Reach ECS components (M3 plan §2.6.5): bitECS 0.4 structure-of-arrays stores with `MAX_ENTITIES` slots, like
 * src/world/components.ts. Add them with `addComponent(sim.world, eid, ReachSpawn)`; write the slots directly.
 */
import { MAX_ENTITIES } from '../world/components'
import type { ReachSpawnKind } from './runtime/types'

/** A damageable objective the AI besieges (the relay during a reboot, D-TBD 12): weighed at distance / weight. */
export const SiegeObjective = { weight: new Float32Array(MAX_ENTITIES) }

/** Ships the Reach spawned: their group, why (`REACH_SPAWN_KIND`) and the player distance beyond which they despawn. */
export const ReachSpawn = { group: new Int32Array(MAX_ENTITIES), kind: new Uint8Array(MAX_ENTITIES), despawnM: new Float32Array(MAX_ENTITIES) }

/** `ReachSpawn.kind` codes. */
export const REACH_SPAWN_KIND = { interdictor: 0, baseDefender: 1, rebootRaider: 2, guardian: 3, patrol: 4, ally: 5 } as const satisfies Record<
  ReachSpawnKind,
  number
>
